// extracted by mini-css-extract-plugin
module.exports = {"header":"tenants_header__y_CMD","table":"tenants_table__1j6m1","filters":"tenants_filters__3m51J","row":"tenants_row__2344f","submitBtns":"tenants_submitBtns__1joaZ"};